import styled, { css } from 'styled-components/macro'

type ButtonStyleProps = {
  type?: 'button-primary' | 'button-secondary'
  disabled?: boolean
}

export const Wrapper = styled.div<ButtonStyleProps>`
  font-family: 'GoldplayMedium', sans-serif;
  font-style: normal;
  display: inline-flex;
  width: auto;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  letter-spacing: 0.05em;
  padding: 10.5px 50px;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.1s;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0);
  text-align: center;
  white-space: nowrap;

  ${(props) => {
    if (props.type === 'button-primary') {
      return css`
        color: #ffffff;
        background: #e98fb6;
        transition: 0.1s;

        &:hover {
          opacity: 0.85;
        }

        ${props.disabled &&
        `
                color: #FDF7F2;
                background: #CAAEB9;
                cursor: default;
                
                &:hover {
                  opacity: unset !important;
                }
            `}
      `
    }
    if (props.type === 'button-secondary') {
      return css`
        color: #a46edd;
        background: #efe6f9;
        transition: 0.1s;

        &:hover {
          opacity: 0.85;
        }

        ${props.disabled &&
        `
                color: #847c8df5;
                background: #efe6f9;
                cursor: default;
                
                &:hover {
                  opacity: unset !important;
                }
            `}
      `
    }
  }}
`
